import React from 'react';
import "./Education.css"
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {FaGraduationCap } from "react-icons/fa";

const Education = () => {

const data=[

{
    name:"Sandip University",
    degre:"MCA",
    year:"Pursuing",
    des:"Pursuing My Post-Graduation in MCA. It will get completed wihin prevous 2 years (2024)."
},
{
    name:"Savitribai Phule Pune University",
    degre:"BCS",
    year:"2022",
    des:"Completed MY Graduation in 2022 from Maharashtra Board with securing A+ Grade In computer Science. The total percentage is 81.45% with the CGPA of 8.45."
},
{
    name:"Silver-Oak Universal College Of Commerce And Science",
    degre:"HSC",
    year:"2019",
    des:"Completed My HSC examination in 2019 from Maharashtra Board with securing A grade. The total percentage is 60.9%. Having subjects Physics , Chemistry , Math & Computer Science."
},
{
    name:"Fravashi Academy",
    degre:"SSC",
    year:"2017",
    des:"Completed My SSC examination in 2017 from Maharashtra Board with securing A Grade. The Total Percentage is 69.8%. "
}

];
const colors=[
    "#FFBB24",
    "#001CCE",
    "#FF6347",
    "#800000",
    "#4B088A"
];

    return (
<div>
<div className='container education-section' id="education">
<div className="section-title">
        <h5>Education</h5>
        <span className="line"></span>
      </div>
</div>

<div className="timeline-section">
       <VerticalTimeline lineColor='#FF1042'>

{data.map((item,index)=>(
     <VerticalTimelineElement
     className="vertical-timeline-element--work"
     contentStyle={{ background: colors[index], color: '#fff' }}
     contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
     date={item.year}
     dateClassName="date-class"
     iconStyle={{ background: colors[index], color: '#fff' }}
     icon={<FaGraduationCap />}
   >
     <h3 className="vertical-timeline-element-title">{item.name}</h3>
     <h5 className="vertical-timeline-element-subtitle" style={{color:"yellow"}} >   {item.degre} </h5>

    

     <p>{item.des}</p>
   </VerticalTimelineElement>
))}
</VerticalTimeline>
</div>


</div>
        );
    };
    export default Education;